import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../axios";

const CreateCoupon = () => {
  const [form, setForm] = useState({
    code: "",
    description: "",
    percentage: 0,
    valid_from: "",
    valid_until: "",
    is_active: true,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    if (name === "percentage") {
      const num = Number(newValue);
      if (num > 100) newValue = 100;
      if (num < 0) newValue = 0;
    }

    setForm({
      ...form,
      [name]: newValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const payload = {
        code: form.code,
        description: form.description,
        discount_type: "percentage",
        discount_value: form.percentage,
        valid_from: form.valid_from,
        valid_until: form.valid_until,
        is_active: form.is_active,
      };

      await axiosClient.post("/api/coupons", payload);

      // redirect after successful creation
      navigate("/xl-admin/coupons");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to create coupon");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <h2 className="h5 mb-0">Create Coupon</h2>
          <p className="text-muted mb-0 small">
            Create discount coupons for your customers
          </p>
        </div>

        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Coupon Code</label>
                <input
                  type="text"
                  name="code"
                  value={form.code}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="e.g. SUMMER25"
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">
                  Discount Percentage
                </label>
                <div className="input-group">
                  <input
                    type="number"
                    name="percentage"
                    value={form.percentage}
                    onChange={handleChange}
                    min="0"
                    max="100"
                    className="form-control"
                    placeholder="0-100%"
                  />
                  <span className="input-group-text">%</span>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">Description</label>
              <textarea
                name="description"
                value={form.description}
                onChange={handleChange}
                className="form-control"
                rows="3"
                placeholder="Describe the purpose of this coupon..."
              />
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Valid From</label>
                <input
                  type="date"
                  name="valid_from"
                  value={form.valid_from}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Valid Until</label>
                <input
                  type="date"
                  name="valid_until"
                  value={form.valid_until}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
            </div>

            <div className="form-check form-switch mb-4">
              <input
                type="checkbox"
                name="is_active"
                checked={form.is_active}
                onChange={handleChange}
                className="form-check-input"
                id="isActive"
              />
              <label
                className="form-check-label fw-semibold"
                htmlFor="isActive"
              >
                Active Coupon
              </label>
            </div>

            <div className="d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={loading}
              >
                {loading ? "Creating..." : "Create Coupon"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateCoupon;
